import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./styles";

const OneParkInviteTable = ({ rows, order, orderBy, onSort, selectedIds, onToggleSelection }) => {
  const classes = useStyles();

  const columns = [
    { key: "firstName", label: "First Name" },
    { key: "lastName", label: "Last Name" },
    { key: "email", label: "Email" },
    { key: "lastUse", label: "Last Use" },
  ];

  return (
    <Table className={clsx(classes.table, "onepark-invite-table")}>
        <TableHead>
          <TableRow className={clsx(classes.headerRow, "onepark-invite-header-row")}>
            <TableCell className={clsx(classes.headerCell, classes.selectCell, "onepark-invite-header-select")} />
            {columns.map((col) => (
              <TableCell key={col.key} className={clsx(classes.headerCell, `onepark-invite-header-${col.key}`)}>
                <TableSortLabel
                  active={orderBy === col.key}
                  direction={orderBy === col.key ? order : "asc"}
                  onClick={() => onSort(col.key)}
                >
                  {col.label}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} className={clsx(classes.bodyRow, `onepark-invite-row-${row.id}`)}>
              <TableCell className={clsx(classes.bodyCell, classes.selectCell, "onepark-invite-cell-select")}>
                <input
                  type="checkbox"
                  checked={selectedIds.has(row.id)}
                  disabled={!row.email}
                  onChange={() => onToggleSelection(row.id)}
                  aria-label={`Select ${row.firstName || ""} ${row.lastName || ""}`.trim()}
                />
              </TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-invite-cell-firstName")}>{row.firstName || "–"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-invite-cell-lastName")}>{row.lastName || "–"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-invite-cell-email")}>{row.email || "–"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-invite-cell-lastUse")}>{row.lastUse || "–"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
    </Table>
  );
};

export default OneParkInviteTable;
